import React from 'react';
import InputForm from "../../../../components/Basic/InputForm";
import { useEditVessel } from "../../../../contexts/EditVesselContext";
import { vesselForm } from "../constants";

interface IProps {
}

const VesselCapacity: React.FC<IProps> = () => {
    const [value, setStore] = useEditVessel(state => state.vessel?.capacity)
    const [error] = useEditVessel(state => state.error?.capacity)
    const { label, type, rules, suffix } = vesselForm.capacity;

    const { [type]: Input } = InputForm;

    return <Input
        label={label}
        error={error}
        require={rules.requireZero}
        suffix={suffix}
        value={value ? value / 1000000 : value}
        onChange={newValue => setStore(({ vessel: old }) => ({ vessel: { ...old, capacity: newValue * 1000000 } }))}
    />;
};

export default VesselCapacity;
